import { render, staticRenderFns } from "./ipVisitList.vue?vue&type=template&id=624de33a&scoped=true&"
import script from "./ipVisitList.vue?vue&type=script&lang=js&"
export * from "./ipVisitList.vue?vue&type=script&lang=js&"
import style0 from "./ipVisitList.vue?vue&type=style&index=0&id=624de33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624de33a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624de33a')) {
      api.createRecord('624de33a', component.options)
    } else {
      api.reload('624de33a', component.options)
    }
    module.hot.accept("./ipVisitList.vue?vue&type=template&id=624de33a&scoped=true&", function () {
      api.rerender('624de33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/safe/child/ipVisitList.vue"
export default component.exports